import * as actionTypes from "../actions/types";
import axios from "../../axios";
import { openEdifySpinner } from ".";

export const openMainModalDashboard = (config) => {
  return {
    type: actionTypes.OPEN_MAIN_MODAL,
    payload: config,
  };
};

export const setPreviousLocation = (location) => {
  return {
    type: actionTypes.SET_PREVIOUS_LOCATION,
    payload: location,
  }
}

export const closeTutorialModal = () => {
  return {
    type: actionTypes.CLOSE_TUTORIAL_MODAL,
  };
};

export const openTutorialModal = () => {
  return {
    type: actionTypes.OPEN_TUTORIAL_MODAL,
  };
};

export const setTutorialStep = (step) => {
  return {
    type: actionTypes.SET_TUTORIAL_STEP,
    payload: step,
  };
};

export const setTutorialCompleted = () => {
  return {
    type: actionTypes.SET_TUTORIAL_COMPLETED,
  };
};

export const resetTutorial = () => {
  return {
    type: actionTypes.RESET_TUTORIAL,
  };
};

export const skipTutorial = () => {
  return {
    type: actionTypes.SKIP_TUTORIAL,
  };
};

export const resetRecentPost = () => {
  return {
    type: actionTypes.RECENT_POST,
    payload: [],
  };
};

//Acciones para Sección Que Pasa en Edify?

//Obtener total de usuarios 

export const getTotalUsers = () => {
  let tipoUrl = `/user/allUsers`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_TOTAL_USERS,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

//obtener los últimos usuarios registrados

export const getLastNewUsers = () => {
  let tipoUrl = `/user/lastUsers`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_LAST_NEW_USERS,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

//Obtener total de obras públicas

export const getTotalPublicProjects = () => {
  let tipoUrl = `proyecto/allProjects?type=PUBLIC`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        const totalPublicProjects = res.data.length;
        const lastPublicProject = res.data[res.data.length - 1];
        dispatch({
          type: actionTypes.GET_TOTAL_PUBLIC_PROJECTS,
          payload: { totalPublicProjects, lastPublicProject },
        });
      })
      .catch((err) => { });
  };
};

//Obtener total de obras privadas

export const getTotalPrivateProjects = () => {
  let tipoUrl = `proyecto/allProjects?type=PRIVATE`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_TOTAL_PRIVATE_PROJECTS,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.log(err)
       });
  };
};

//Obtener total de cotizaciones públicas

export const getTotalPublicQuotations = () => {
  let tipoUrl = `quotation/allQuotations?type=PUBLIC`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        const totalPublicQuotations = res.data[1];
        const lastPublicQuotation = res.data[0][res.data[0].length - 1];
        dispatch({
          type: actionTypes.GET_TOTAL_PUBLIC_QUOTATIONS,
          payload: { totalPublicQuotations, lastPublicQuotation },
        });
      })
      .catch((err) => { });
  };
};

//Obtener total de Adjudicaciónes en el último año
export const getTotalAdjudications = () => {
  let tipoUrl = `adjudicados/get/getByFilter?type=PUBLIC&order=DESC&page=1&take=10`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        const totalAdjudications = res.data.itemCount;
        const lastAdjudicatedProject = res.data.entities[0];
        dispatch({
          type: actionTypes.GET_TOTAL_ADJUDICATED_PROJECTS,
          payload: totalAdjudications,
        });
        dispatch({
          type: actionTypes.GET_LAST_ADJUDICATED_PROJECT,
          payload: lastAdjudicatedProject,
        });
      })
      .catch((err) => {
        console.log(err)
      });
  }
}

//Obtener la última obra pública adjudicada
export const getLastAdjudicatedProject = () => {
  let tipoUrl = `adjudicados/lastAdjudicated `;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        const lastAdjudicatedProject = res.data[0];
        dispatch({
          type: actionTypes.GET_LAST_ADJUDICATED_PROJECT,
          payload: lastAdjudicatedProject,
        });
      })
      .catch((err) => {
        console.log(err)
      });
  }
}


//Obtener total de cotizaciones públicas el ultimo mes

export const getTotalNewPublicQuotations = () => {
  let tipoUrl = `quotation/lastQuotations?type=PUBLIC`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        const totalNewPublicQuotations = res.data.length;
        dispatch({
          type: actionTypes.GET_TOTAL_NEW_PUBLIC_QUOTATIONS,
          payload: totalNewPublicQuotations,
        });
      })
      .catch((err) => { });
  };
};

//Obtener total de cotizaciones privadas

export const getTotalPrivateQuotations = () => {
  let tipoUrl = `quotation/allQuotations?type=PRIVATE`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {

        dispatch({
          type: actionTypes.GET_TOTAL_PRIVATE_QUOTATIONS,
          payload: res.data[0],
        });
      })
      .catch((err) => {
        console.log(err)
      });
  };
};

//Obtener total de cotizaciones privadas el ultimo mes

export const getTotalNewPrivateQuotations = () => {
  let tipoUrl = `quotation/lastQuotations?type=PRIVATE`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        const totalNewPrivateQuotations = res.data.length;
        dispatch({
          type: actionTypes.GET_TOTAL_NEW_PRIVATE_QUOTATIONS,
          payload: totalNewPrivateQuotations,
        });
      })
      .catch((err) => { });
  };
};

//Obtener el resúmen de actividades de un usuario
export const getUserActivitySummary = (userId) => {
  let tipoUrl = `/user/activity/${userId}`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_USER_ACTIVITY_SUMMARY,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.log(err)
      }
      );
  };
};

//Obtener todos los portfolios de los usuarios
export const getAllPortfolios = () => {
  let tipoUrl = `/portfolio/getAll`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_ALL_PORTFOLIOS,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.log(err)
      });
  };
};


//Obtener todos los posteos
export const getPosteos = (order, type) => {
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    dispatch({ type: actionTypes.START_LOADING });
    axios
      .get(`posteo/list?order=${order}&type=${type}`, bearerToken)
      .then((res) => {
        dispatch({ type: actionTypes.END_LOADING });
        dispatch({
          type: actionTypes.GET_POSTEOS,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.log(err)
        dispatch({ type: actionTypes.END_LOADING });
      });
  };
};

//Obtener los posteos propios
export const getOwnPosteos = (userId) => {

  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    dispatch({ type: actionTypes.START_LOADING });
    axios
      .get(`posteo/user?userFind=${userId}`, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_OWN_POSTEOS,
          payload: res.data,
        });
        dispatch({ type: actionTypes.END_LOADING });

      })
      .catch((err) => {
        dispatch({ type: actionTypes.END_LOADING });
        console.log(err)
      });
  };
};


//crear un posteo en el muro
export const createPost = (body) => {
  let {
    images,
    video,
    content,
  } = body;
  const formData = new FormData();
  formData.append("content", content);
  formData.append("video", video);
  formData.append("images", images);

  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}`, "content-type": "multipart/form-data" } };


  return (dispatch) => {
    dispatch(openEdifySpinner(true));
    axios
      .post("/posteo/create", formData, bearerToken)
      .then((res) => {
        dispatch(openEdifySpinner(false));
        dispatch(
          openMainModalDashboard({
            title: "¡Listo!",
            body: "Tu posteo se ha creado con éxito",
            iconType: "success",
            isSuccess: true,
            confirmHandler: null,
          })
        );
        dispatch({ type: actionTypes.RECENT_POST, payload: res.data })
        dispatch(getPosteos("DESC", "DATE"));
      })
      .catch((err) => {
        dispatch(openEdifySpinner(false));
        dispatch(
          openMainModalDashboard({
            title: "¡Ups!",
            body: "Tu posteo no se ha podido crear, por favor intenta nuevamente o escribenos a contacto@edify.la ¡Muchas gracias!",
            isSuccess: false,
            confirmHandler: null,
          })
        );
      });
  };
};


export const getPosteoById = (id) => {
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return async (dispatch) => {
    try {
      const [postResponse, commentsResponse] = await Promise.all([
        axios.get(`/posteo/${id}`, bearerToken),
        axios.get(`/posteo/comments/${id}`, bearerToken)
      ]);

      const normalizedComments = commentsResponse.data.response || [];

      dispatch({
        type: actionTypes.GET_POSTEO_WITH_COMMENTS,
        payload: {
          post: postResponse.data,
          comments: normalizedComments
        }
      });
    } catch (err) {
      console.log(err);
    }
  };
};


//Editar un posteo 
export const editPosteo = (body) => {
  let {
    id,
    images,
    video,
    content,
  } = body;

  const formData = new FormData();
  formData.append("id", parseInt(id));
  formData.append("content", content);
  formData.append("video", video);
  formData.append("images", images);


  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}`, "content-type": "multipart/form-data" } };

  return (dispatch) => {
    dispatch(openEdifySpinner(true));
    axios
      .patch(`/posteo/update`, formData, bearerToken)
      .then((res) => {
        dispatch(openEdifySpinner(false));
        dispatch({type: actionTypes.UPDATE_POSTEO_INFO, payload: { posteo: res.data } });
        dispatch(
          openMainModalDashboard({
            title: "¡Listo!",
            body: "Tu posteo se ha editado con éxito",
            isSuccess: true,
            confirmHandler: null,
          })
        );
      })
      .catch((err) => {
        dispatch(openEdifySpinner(false));
        dispatch(
          openMainModalDashboard({
            title: "¡Ups!",
            body: "Tu posteo no se ha podido editar, por favor intenta nuevamente o escribenos a contacto@edify.la ¡Muchas gracias!",
            isSuccess: true,
            confirmHandler: null,
          })
        );
      });
  };
};

//Eliminar un posteo
export const deletePost = (id) => {
  let authToken = localStorage.getItem("access-Token-Edify");

  return (dispatch) => {
    axios
      .delete("/posteo/delete", {
        headers: { Authorization: `Bearer ${authToken}` },
        data: {
          idPost: parseInt(id),
        },
      })
      .then((res) => {
        dispatch(
          openMainModalDashboard({
            title: "¡Listo!",
            body: "Tu posteo se ha eliminado con éxito",
            isSuccess: true,
            confirmHandler: null,
          })
        );
        dispatch(getPosteos("DESC", "DATE"));
      })
      .catch((err) => {
        dispatch(
          openMainModalDashboard({
            title: "¡Ups!",
            body: "Tu posteo no se ha podido eliminar, por favor intenta nuevamente o escribenos a contacto@edify.la ¡Muchas gracias!",
            isSuccess: false,
            confirmHandler: null,
          })
        );
      });
  };
};



//Dar like a un posteo
export const likePost = (id) => {
  const body = { post_id: parseInt(id) };
  const authToken = localStorage.getItem("access-Token-Edify");
  const bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    dispatch({ type: actionTypes.PROGRESS_BAR_LOADER, payload: true });
    axios
      .post("/posteo/like", body, bearerToken)
      .then((res) => {
        dispatch({ type: actionTypes.PROGRESS_BAR_LOADER, payload: false });
        dispatch(getPosteoById(id));
      }
      )
      .catch((err) => {
        dispatch({ type: actionTypes.PROGRESS_BAR_LOADER, payload: false });
        console.log(err)
        dispatch(
          openMainModalDashboard({
            title: "¡Ups!",
            body: "Tu like no se ha podido registrar, por favor intenta nuevamente o escribenos a contacto@edify.la ¡Muchas gracias!",
            isSuccess: false,
            confirmHandler: null,
            iconType: "error",
          })
        );
      });
  };
};

//Obtener todos los comentarios de un post
export const getPostComments = (postId) => {
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    axios
      .get(`/posteo/comments/${postId}`, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_POSTEO_COMMENTS,
          payload: { postId, comments: res.data.response },
        });
      })
      .catch((err) => {
        console.log(err)
      });
  };
};



//Crea un comentario en el post
export const createPostComment = (postId, content) => {
  const body = {
    postId: postId,
    content: content,
  };

  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    dispatch({ type: actionTypes.PROGRESS_BAR_LOADER, payload: true });
    axios
      .post("/posteo/comment", body, bearerToken)
      .then((res) => {
        dispatch({ type: actionTypes.PROGRESS_BAR_LOADER, payload: false });
        dispatch(getPosteoById(postId));
        dispatch(
          openMainModalDashboard({
            title: "¡Listo!",
            body: "Tu comentario ha sido publicado en el muro",
            iconType: "success",
            isSuccess: true,
            confirmHandler: null,
          })
        );
      })
      .catch((err) => {
        dispatch({ type: actionTypes.PROGRESS_BAR_LOADER, payload: false });
        dispatch(
          openMainModalDashboard({
            title: "¡Ups!",
            body: "Tu comentario no se ha podido publicar, por favor intenta nuevamente o escribenos a contact@edify.la para que podamos ayudarte ¡Muchas gracias!",
            isSuccess: false,
            confirmHandler: null,
            iconType: "error",
          })
        );
      });
  };
};

//Edita un comentario en un posteo
export const editPostComment = (commentId, content, id) => {
  const body = {
    commentId: parseInt(commentId),
    content: content,
  };

  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    dispatch({ type: actionTypes.PROGRESS_BAR_LOADER, payload: true });
    axios
      .patch("/posteo/comment/update", body, bearerToken)
      .then((res) => {
        dispatch({ type: actionTypes.PROGRESS_BAR_LOADER, payload: false });
        dispatch(
          openMainModalDashboard({
            title: "¡Listo!",
            body: "Tu comentario se ha editado con éxito",
            isSuccess: true,
            confirmHandler: null,
            iconType: "success",
          })
        );
        dispatch(getPosteoById(id));
      })
      .catch((err) => {
        dispatch({ type: actionTypes.PROGRESS_BAR_LOADER, payload: false });
        dispatch(
          openMainModalDashboard({
            title: "¡Ups!",
            body: "Tu comentario no se ha podido editar, por favor intenta nuevamente o escribenos a contacto@edify.la para que podamos ayudarte ¡Muchas gracias!",
            isSuccess: false,
            confirmHandler: null,
          })
        );
      });
  };
};

//Dar like a un comentario en un posteo
export const likePostComment = (commentId, postId) => {
  const body = {
    post_comment_id: parseInt(commentId),
  };

  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    dispatch({ type: actionTypes.PROGRESS_BAR_LOADER, payload: true });
    axios
      .post("/posteo/comment/like", body, bearerToken)
      .then((res) => {
        dispatch({ type: actionTypes.PROGRESS_BAR_LOADER, payload: false });
        dispatch(getPosteoById(postId));
      })
      .catch((err) => {
        dispatch({ type: actionTypes.PROGRESS_BAR_LOADER, payload: false });
        console.log(err)
      });
  };
};

//Responder a un comentario en un posteo
export const responsePostComment = (postId, commentId, content) => {
  const body = {
    postId: parseInt(postId),
    commentId: parseInt(commentId),
    content: content,
  };

  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    dispatch({ type: actionTypes.PROGRESS_BAR_LOADER, payload: true });
    axios
      .post("/posteo/comment/response", body, bearerToken)
      .then((res) => {
        dispatch({ type: actionTypes.PROGRESS_BAR_LOADER, payload: false });
        dispatch(
          openMainModalDashboard({
            title: "¡Listo!",
            body: "Tu respuesta ha sido publicada en el muro",
            isSuccess: true,
            confirmHandler: null,
            iconType: "success",
          })
        );
        dispatch(getPosteoById(postId));
      })
      .catch((err) => {
        dispatch({ type: actionTypes.PROGRESS_BAR_LOADER, payload: false });
        dispatch(
          openMainModalDashboard({
            title: "¡Ups!",
            body: "Tu respuesta no se ha podido publicar, por favor intenta nuevamente o escribenos a contacto@edify.la para que podamos ayudarte ¡Muchas gracias!",
            isSuccess: true,
            confirmHandler: null,
            iconType: "error",
          })
        );
      });
  };
};

//Elimina un comentario en un posteo
export const deletePostComment = (idComment, id) => {
  let authToken = localStorage.getItem("access-Token-Edify");

  return (dispatch) => {
    dispatch({ type: actionTypes.PROGRESS_BAR_LOADER, payload: true });
    axios
      .delete("/posteo/comment/delete", {
        headers: { Authorization: `Bearer ${authToken}` },
        data: {
          idComment: parseInt(idComment),
        },
      })
      .then((res) => {
        dispatch({ type: actionTypes.PROGRESS_BAR_LOADER, payload: false });
        dispatch(
          openMainModalDashboard({
            title: "¡Listo!",
            body: "Tu comentario se ha eliminado con éxito",
            isSuccess: true,
            confirmHandler: null,
            iconType: "success",
          })
        );
        dispatch(getPosteoById(id));
      })
      .catch((err) => {
        dispatch({ type: actionTypes.PROGRESS_BAR_LOADER, payload: false });
        dispatch(
          openMainModalDashboard({
            title: "¡Error!",
            body: "Tu comentario no se ha podido eliminar",
            isSuccess: false,
            confirmHandler: null,
            iconType: "error",
          })
        );
      });
  };
};

//Filtrador de proyectos públicos
export const filterPublicProjects = (searchParams, page, take) => {

  let orderParam = `${searchParams.sort ? searchParams.sort : "DESC"}`;
  let nameParam = `${searchParams.asociatedWords ? "&nombre=" + searchParams.asociatedWords : ""}`;
  let zoneParam = `${searchParams.zone ? "&zone=" + searchParams.zone : ""}`;
  let minAmountParam = `${searchParams.minAmount ? "&montoMin=" + searchParams.minAmount : ""}`;
  let maxAmountParam = `${searchParams.maxAmount ? "&montoMax=" + searchParams.maxAmount : ""}`;
  let currencyParam = `${searchParams.currency ? "&currency=" + searchParams.currency : ""}`;
  let jurisdictionParam = `${searchParams.jurisdiction ? "&jurisdiccion=" + searchParams.jurisdiction : ""}`;
  let organismParam = `${searchParams.organism ? "&organismo=" + searchParams.organism : ""}`;
  let obra_type = `${searchParams.workType ? "&obra_type=" + searchParams.workType : ""}`;
  let sinceParam = `${searchParams.dateRange?.dateFrom ? "&dateFrom=" + searchParams.dateRange.dateFrom : ""}`;
  let untilParam = `${searchParams.dateRange?.dateTo ? "&dateTo=" + searchParams.dateRange.dateTo : ""}`;
  let tipoUrl = searchParams.projectType === "Adjudicadas" ? `/adjudicados/get/getByFilter?type=PUBLIC&order=${orderParam}&page=${page}&take=${take}`
    : `/proyecto/get/getPublicsByFilter?type=PUBLIC&order=${orderParam}&page=${page}&take=${take}`;

  let sendURL = `${tipoUrl}${nameParam}${zoneParam}${minAmountParam}${maxAmountParam}${currencyParam}${jurisdictionParam}${organismParam}${obra_type}${sinceParam}${untilParam}`;

  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_DASHBOARD_PROJECTS_LOADING,
      payload: true,
    });
    axios
      .get(sendURL, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_DASHBOARD_PROJECTS,
          payload: {
            data: res.data.entities,
            itemCount: res?.data?.itemCount,
            take: res?.data?.take,
          }
        });
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: actionTypes.GET_DASHBOARD_PROJECTS_LOADING,
          payload: false,
        });
      });
  };
};

export const filterQuotations = (searchParams, page, take) => {
  let orderParam = `${searchParams.sort ? searchParams.sort : "DESC"}`;
  let nameParam = `${searchParams.asociatedWords ? "&nombre=" + searchParams.asociatedWords : ""}`;
  let zoneParam = `${searchParams.zone ? "&zone=" + searchParams.zone : ""}`;
  let minAmountParam = searchParams.projectType === "Privadas" ? "" : `${searchParams.minAmount ? "&montoMin=" + searchParams.minAmount : ""}`;
  let maxAmountParam = searchParams.projectType === "Privadas" ? "" : `${searchParams.maxAmount ? "&montoMax=" + searchParams.maxAmount : ""}`;
  let currencyParam = `${searchParams.currency ? "&currency=" + searchParams.currency : ""}`;
  let jurisdictionParam = `${searchParams.jurisdiction ? "&jurisdiccion=" + searchParams.jurisdiction : ""}`;
  let organismParam = `${searchParams.organism ? "&organismo=" + searchParams.organism : ""}`;
  let obra_type = searchParams.projectType === "Privadas" ? `${searchParams.workType ? "&category=" + searchParams.workType : ""}`
    : `${searchParams.workType ? "&obra_type=" + searchParams.workType : ""}`;
  let sinceParam = `${searchParams.dateRange?.dateFrom ? "&dateFrom=" + searchParams.dateRange.dateFrom : ""}`;
  let untilParam = `${searchParams.dateRange?.dateTo ? "&dateTo=" + searchParams.dateRange.dateTo : ""}`;
  let tipoUrl = searchParams.projectType === "Privadas" ? `/quotation/getByFilter?type=PRIVATE&order=${orderParam}&page=${page}&take=${take}&active=true`
    : `/quotation/get/getPublicsByFilter?type=PUBLIC&order=${orderParam}&page=${page}&take=${take}&active=true`;

  let sendURL = `${tipoUrl}${nameParam}${zoneParam}${minAmountParam}${maxAmountParam}${currencyParam}${jurisdictionParam}${organismParam}${obra_type}${sinceParam}${untilParam}`;

  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_DASHBOARD_PROJECTS_LOADING,
      payload: true,
    });
    axios
      .get(sendURL, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_QUOTATIONS_TYPE,
          payload: res.data,
          page,
          itemCount: res?.data?.itemCount,
          take: res?.data?.take,
        });
        dispatch({
          type: actionTypes.GET_DASHBOARD_PROJECTS_LOADING,
          payload: false,
        });
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: actionTypes.GET_DASHBOARD_PROJECTS_LOADING,
          payload: false,
        });
      });
  };
};

export const filterPrivateProjects = (searchParams, page, take, clear) => {

  let orderParam = `${searchParams.sort ? searchParams.sort : "DESC"}`;
  let zoneParam = `${searchParams.zone ? "&ubicacion=" + searchParams.zone : ""}`;
  let workTypeParam = `${searchParams.workType ? "&subproyecto=" + searchParams.workType : ""}`;
  let sinceParam = `${searchParams.dateRange?.dateFrom ? "&dateFrom=" + searchParams.dateRange.dateFrom : ""}`;
  let untilParam = `${searchParams.dateRange?.dateTo ? "&dateTo=" + searchParams.dateRange.dateTo : ""}`;

  let tipoUrl = `/proyecto/get/getPrivatesByFilter?type=PRIVATE&order=${orderParam}&page=${page}&take=${take}`;

  let sendURL = clear ? `${tipoUrl}` : `${tipoUrl}${zoneParam}${workTypeParam}${sinceParam}${untilParam}`;

  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_DASHBOARD_PROJECTS_LOADING,
      payload: true,
    });
    axios
      .get(sendURL, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_DASHBOARD_PROJECTS,
          payload: {
            data: res.data.entities,
            itemCount: res?.data?.itemCount,
            take: res?.data?.take,
          }
        });
        dispatch({
          type: actionTypes.GET_DASHBOARD_PROJECTS_LOADING,
          payload: false,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.GET_DASHBOARD_PROJECTS_LOADING,
          payload: false,
        });
      });
  };
};


//Ver Perfil Externo
const setProfileVisualizerData = (data) => {
  return {
    type: actionTypes.SET_PROFILE_VISUALIZER,
    payload: data,
  };
};

export const getProfileVisualizer = (id) => {
  let tipoUrl = `/user/data?userFind=${id}`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    dispatch({ type: actionTypes.START_LOADING });
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        dispatch(setProfileVisualizerData({ ...res.data, id: id }));
        dispatch({ type: actionTypes.END_LOADING });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: actionTypes.END_LOADING });
      });
  };
};

export const clearProjects = () => {
  return {
    type: actionTypes.CLEAR_PROJECTS,
  };
};





